var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowforward({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "13px",
    viewBox: "0 0 8 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Forward") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-----UI-v5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "template-/-authenticated-copy",
    transform: "translate(-359.000000, -198.000000)",
    fill: "#324047",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button/Text-CTA",
    transform: "translate(269.000000, 193.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Forward",
    transform: "translate(82.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Arrow",
    transform: "translate(12.000000, 11.705000) rotate(-270.000000) translate(-12.000000, -11.705000) ",
    points: "7.41 15.41 12 10.83 16.59 15.41 18 14 12 8 6 14"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowforward);
export default __webpack_public_path__ + "static/media/arrowforward.584fab916c241289d2b2104188b86ef5.svg";
export { ForwardRef as ReactComponent };